const resetPathMap = new Map()
  .set('homePath', [{ routerName: 'home', text: '首页' }])
  .set('productPath', [{ routerName: 'home', text: '首页' }, { routerName: 'product', text: '金融产品' }])
  .set('loanDetailPath', [{ routerName: 'loan', text: '我的贷款' }, { routerName: 'loan-detail', text: '订单详情' }])

const breadMap = new Map()
  .set('home', '首页')
  .set('product', '金融产品')
  .set('product-detail', '产品详情')
  .set('financing-apply', '发起融资')
  .set('order-confirm', '提交订单')
  .set('match-product', '匹配产品')
  .set('loan-detail', '订单详情')

export {
  resetPathMap,
  breadMap
}
